import {Component, Input} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {GesellschaftZusatzangaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-bezeichnung-kg-angaben',
  templateUrl: './bezeichnung-kg-angaben.component.html'
})
export class BezeichnungKgAngabenComponent extends FormBaseComponent<GesellschaftZusatzangaben> {

  @Input()
  public kgTitle: string;

  @Input()
  public taetigTitle: string;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly activatedRoute: ActivatedRoute) {
    super(messageService);
  }

  public isKomplementaerKgChanged(): void {
    this.form.controls.bezeichnungKg.updateValueAndValidity();
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      isKomplementaerKg: [
        this.data?.isKomplementaerKg, []],
      isGewerblichTaetig: [
        this.data?.isGewerblichTaetig, []],
      bezeichnungKg: [
        this.data?.bezeichnungKg, [
          this.validatorService.maxLength(100),
          this.validatorService.minLength(1),
          this.validatorService.conditionalValidator(() =>
              this.data.isKomplementaerKg,
            this.validatorService.required()
          )
        ]]
    });
  }

}
